// extracted by mini-css-extract-plugin
export default {"offerNotification":"B1zxx","collapseLink":"KOTXE","underscored":"VA0ii","collapsed":"dcfOn","show":"z6XDY","up":"aU1mu","down":"kvAWn"};